(function () {
  function getUTMParams() {
    const params = new URLSearchParams(window.location.search);
    const utms = {};
    for (const [key, value] of params.entries()) {
      if (key.startsWith("utm_")) {
        utms[key] = value;
      }
    }
    return utms;
  }

  const currentUTMs = getUTMParams();
  if (Object.keys(currentUTMs).length > 0) {
    sessionStorage.setItem("utmParams", JSON.stringify(currentUTMs));
  }

  function getStoredUTMParams() {
    const stored = sessionStorage.getItem("utmParams");
    return stored ? JSON.parse(stored) : {};
  }

  function appendUTMsToLink(link) {
    const utms = getStoredUTMParams();
    if (Object.keys(utms).length === 0) return;

    const url = new URL(link.href);
    for (const key in utms) {
      url.searchParams.set(key, utms[key]);
    }
    link.href = url.toString();
  }

  document.addEventListener("DOMContentLoaded", function () {
    const botoes = document.querySelectorAll(
      'a.subscribe-button, a[href*="cgi.insper.edu.br/Inscricao/lead"]'
    );
    botoes.forEach(link => {
      appendUTMsToLink(link);
    });
  });
})();
